import React from 'react';
import { Surface } from 'react-native-paper';
import { Linking, StyleSheet, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import { SubText } from '@luminate/luminate-native-components';

import { useAuth, useThemeContext } from '../../contexts';
import { SCREEN_NAMES } from '../routes';
import { GradientBar } from './GradientBar';

export const Footer = () => {
  const { theme } = useThemeContext();
  const navigation = useNavigation();
  const { session } = useAuth();

  const styles = StyleSheet.create({
    container: {
      backgroundColor: theme.colors.primary,
    },
    inner: {
      padding: 6,
    },
  });

  const onNavigateToScreen = (screen: string) => {
    // @ts-ignore
    navigation.navigate(screen);
  };

  const getYear = () => {
    return new Date().getFullYear();
  }

  return (
    <Surface style={styles.container}>
      <GradientBar />
      <View style={styles.inner}>
        <View style={{ flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-between', padding: 5, alignItems: 'center' }}>
          <View style={{ flex: 1 }}>
            <SubText style={{ fontSize: 10, color: theme.colors.surface }}>© Copyright {getYear()} Luminate Health Inc.</SubText>
          </View>
          <View style={{ flex: 2, flexDirection: 'row', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            <SubText style={{ marginHorizontal: 5, fontSize: 10, color: theme.colors.surface }} onPress={() => onNavigateToScreen(SCREEN_NAMES.PRIVACY_POLICY)}>
              {session?.appConfig.privacyPolicyUrl && session?.appConfig.privacyPolicyLabel && 'Luminate'} Privacy Policy
            </SubText>
            {session?.appConfig.termsOfServiceUrl && session?.appConfig.termsOfServiceLabel ? (
              <SubText
                style={{ marginHorizontal: 5, fontSize: 10, color: theme.colors.surface }}
                onPress={() => Linking.openURL(`${session?.appConfig.termsOfServiceUrl}`)}
              >
                {session?.appConfig.termsOfServiceLabel}
              </SubText>
            ) : (
              <SubText
                style={{ marginHorizontal: 5, fontSize: 10, color: theme.colors.surface }}
                onPress={() => onNavigateToScreen(SCREEN_NAMES.TERMS_OF_SERVICE)}
              >
                Terms and Conditions
              </SubText>
            )}
            {session?.appConfig.privacyPolicyUrl && session?.appConfig.privacyPolicyLabel && (
              <SubText
                style={{ marginHorizontal: 5, fontSize: 10, color: theme.colors.surface }}
                onPress={() => Linking.openURL(`${session?.appConfig.privacyPolicyUrl}`)}
              >
                {session?.appConfig.privacyPolicyLabel}
              </SubText>
            )}
          </View>
        </View>
      </View>
    </Surface>
  );
};
